document.addEventListener('DOMContentLoaded', () => {
    // 1. Select all the swiper containers
    const swiperContainers = document.querySelectorAll('.swiper');

    swiperContainers.forEach((swiperEl) => {
        // 2. Extract data attributes
        const carouselType = swiperEl.dataset.carouselType || 'slide'; // fallback
        const autoPlay = swiperEl.dataset.autoplay === 'true';
        const speed = parseInt(swiperEl.dataset.speed, 10) || 3000;
        const slidesPerView = parseInt(swiperEl.dataset.slidesPerView, 10) || 1;

        // 2a. Parse breakpoints JSON (if present)
        let breakpoints = {};
        if (swiperEl.dataset.breakpoints) {
            try {
                breakpoints = JSON.parse(swiperEl.dataset.breakpoints);
                // e.g. { "640": {"slidesPerView": 2}, "1024": {"slidesPerView": 3} }
            } catch (err) {
                console.error('Error parsing breakpoints data:', err);
            }
        }

        // 3. Build a base Swiper config
        let config = {
            slidesPerView: slidesPerView,
            loop: true,
            autoplay: autoPlay
                ? {
                    delay: speed,
                    disableOnInteraction: false,
                }
                : false,
            navigation: {
                nextEl: swiperEl.querySelector('.slider-button--next'),
                prevEl: swiperEl.querySelector('.slider-button--prev'),
            },
            breakpoints: transformBreakpointSettings(breakpoints),
            // Add any default config you always want
        };

        // 4. Use a switch for major differences in "carouselType"
        switch (carouselType) {
            case 'fade':
                config.effect = 'fade';
                config.fadeEffect = { crossFade: true };
                break;
            case 'coverflow':
                config.effect = 'coverflow';
                config.coverflowEffect = {
                    rotate: 50,
                    stretch: 0,
                    depth: 100,
                    modifier: 1,
                    slideShadows: true,
                };
                break;
            case 'slide':
            default:
                // 'slide' effect is standard
                config.effect = 'slide';
                // Additional config for 'slide' if needed
                break;
        }

        // 5. Initialize Swiper
        new Swiper(swiperEl, config);
    });

    /**
     * If your breakpoints data is in a form like:
     *   { "640": { "slidesPerView": 2 }, "1024": { "slidesPerView": 3 } }
     * Swiper expects numeric keys, e.g.:
     *   { 640: { slidesPerView: 2 }, 1024: { slidesPerView: 3 } }
     * So we can convert them by mapping string keys => numeric keys
     */
    function transformBreakpointSettings(breakpointsObj) {
        const parsed = {};
        for (let bp in breakpointsObj) {
            parsed[parseInt(bp, 10)] = breakpointsObj[bp];
        }
        return parsed;
    }
});
function swiperApiData() {

    var sliderSelector = '.swiper-container-api', defaultOptions = {
        breakpointsInverse: true,
        observer: true
    };

    var nSlider = document.querySelectorAll(sliderSelector);

    [].forEach.call(nSlider, function (slider, index, arr) {
        var data = slider.getAttribute('data-swiper') || {};

        if (data) {
            var dataOptions = JSON.parse(data);
        }

        slider.options = Object.assign({}, defaultOptions, dataOptions);

        var swiper = new Swiper(slider, slider.options);

        /* stop on hover */
        if (typeof slider.options.autoplay !== 'undefined' && slider.options.autoplay !== false) {
            slider.addEventListener('mouseenter', function (e) {
            });

            slider.addEventListener('mouseleave', function (e) {
            });
        }
    });
}

document.addEventListener("shopify:section:load", function (event) {
    swiperApiData()
});
document.addEventListener('DOMContentLoaded', () => {
    swiperApiData()
});
